import { oneOf } from 'prop-types';
import React from 'react';
import { Badge } from 'reactstrap';

import { InfoTooltip } from '../../generic/Tooltip';
import { campaignLineStatuses, STATUS_COLOR_MAP } from '../constants';
import HELP_TEXTS from '../utils/help-texts';

function CampaignLineStatus({ status }) {
  const color = STATUS_COLOR_MAP[status];
  const isGrantedViaCR = status === campaignLineStatuses.GRANTED_VIA_CR;
  return (
    <Badge pill color={color}>
      {status}
      {isGrantedViaCR && (
        <InfoTooltip target="budget-split-tooltip">
          {HELP_TEXTS.actionButtons.grantedVieCR}
        </InfoTooltip>
      )}
    </Badge>
  );
}

CampaignLineStatus.propTypes = {
  status: oneOf(Object.values(campaignLineStatuses)).isRequired,
};

export default CampaignLineStatus;
